module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-spreadsheet-6345a549.svg";